import { uniqueId } from 'lodash';
import { action, observable } from 'mobx';
import { CXContainerBlock } from '~/components/ClientExperience/OneFlow/models/cx-container-block.model';
import { CXPage } from '~/components/ClientExperience/OneFlow/models/cx-page.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import { IPrintOrder } from '~/types/builder.types';
import { IContainerBlockResponse } from '~/types/server.types';

const MOCK_PRINT_ELEMENT_IDS = {
    page: 'mock_print_page',
    rootBlock: 'mock_root_block'
};

export class PrintController {
    rootStore: CXRootStore;
    @observable breakAfterBlockIds: string[] = [];

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    @action
    createMockPrintRootBlock() {
        const mockRootBlock = new CXContainerBlock(
            <IContainerBlockResponse>{
                type: 'container_block',
                block_id: MOCK_PRINT_ELEMENT_IDS.rootBlock
            },
            this.rootStore.flowViewUiStore.selectedFlow.activeRevision,
            this.rootStore
        );
        this.rootStore.flowViewUiStore.selectedFlow.activeRevision.addBlock(
            mockRootBlock
        );
        return mockRootBlock;
    }

    @action
    createMockPrintCXPage() {
        return new CXPage(
            {
                page_id: MOCK_PRINT_ELEMENT_IDS.page,
                title: 'custom print page',
                order: -Infinity,
                root_block_id: MOCK_PRINT_ELEMENT_IDS.rootBlock,
                cta_text: '',
                completed: null,
                views: null,
                redirect_website_url: null
            },
            this.rootStore.flowViewUiStore.selectedFlow.activeRevision,
            this.rootStore
        );
    }

    @action
    cleanupMockPrint() {
        delete this.rootStore.flowViewUiStore.selectedFlow.activeRevision
            .pagesMap[MOCK_PRINT_ELEMENT_IDS.page];
        delete this.rootStore.flowViewUiStore.selectedFlow.activeRevision
            .blocksMap[MOCK_PRINT_ELEMENT_IDS.rootBlock];

        this.breakAfterBlockIds = [];
    }

    @action
    createMockPageWithBlockIds({ blockIds, breakAfterBlockIds }: IPrintOrder) {
        this.breakAfterBlockIds = breakAfterBlockIds || [];
        const { pages, blocks } = this.rootStore.flowStore;

        const mockRootBlock = this.createMockPrintRootBlock();
        const mockPage = this.createMockPrintCXPage();

        mockRootBlock.children = blockIds.map((blockId, idx) => {
            return {
                block_id: blockId,
                order: idx,
                size: 1,
                _id: uniqueId()
            };
        });

        pages[mockPage.page_id] = mockPage;
        blocks[mockRootBlock.block_id] = mockRootBlock;

        return { mockPage, mockRootBlock };
    }
}
